import { h, Component } from 'preact';
import {JavaScriptIcon, RailsIcon, BootstrapIcon, CssIcon, HtmlIcon} from './../Icons'

export default class HeyTask extends Component {
	render() {
		return (
      <section class="Content border">
        <div class="Container">
          <div class="Product">
            <div class="info">
              <div class="Title">
                <span class="text">HeyTask, 2017</span>
              </div>
							<p>Discover freelance talent for your everyday needs.</p>
							<p><i>Le Wagon bootcamp project</i></p>
              <span style={{ width:'100%' }}>
								<RailsIcon />
								<JavaScriptIcon />
								<HtmlIcon />
								<CssIcon />
							</span>
              <a href="https://github.com/samcorin/hackernews-newtab-ext" class="Button">Source Code</a>
            </div>
            <div class="Image shadow border">
              <img src="https://firebasestorage.googleapis.com/v0/b/homepage-b9f4a.appspot.com/o/heytask-flat-min.png?alt=media&token=c3e03c31-4675-4b33-9e41-7c028151cf76" style={{ border: 'none', boxShadow: 'none' }} alt="HeyTask" />
            </div>
          </div>
        </div>
      </section>
		);
	}
}



// WEBPACK FOOTER //
// ./components/heytask/index.js